import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Header, Icon, Modal } from "semantic-ui-react";

function ConfirmationModal({ data, open, setOpen, onSuccess, dataForOnSuccess, onCancel }) {
  const { t } = useTranslation("common");
  return (
    <div>
      {open && (
        <Modal open={open} size="mini">
          <Header icon>
            <Icon name={data.icon} />
            {data.headerText}
          </Header>
          <Modal.Content>
            <p>{data.text}</p>
            {data.text2 ? <p>{data.text2}</p> : null}
            {data.text3 ? <p>{data.text3}</p> : null}
            {data.text4 ? <p>{data.text4}</p> : null}
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="red"
              onClick={() => {
                setOpen(false);
                onCancel && onCancel();
              }}
            >
              <Icon name="remove" /> {t("modal_cancel")}
            </Button>
            <Button
              data-test="confirmmation_modal_confirm"
              color="green"
              onClick={() => {
                onSuccess(dataForOnSuccess);
                setOpen(false);
              }}
            >
              <Icon name="checkmark" /> {t("modal_confirm")}
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </div>
  );
}

export default ConfirmationModal;
